import React, {useEffect, useState} from 'react';
import {Image, Layer, Stage} from "react-konva";
import {
    INSTAGRAM_IMAGE_SIZE_1_TO_1,
    INSTAGRAM_IMAGE_SIZE_4_TO_5,
    INSTAGRAM_IMAGE_SIZE_ORIGINAL,
    SHOPIFY_PRODUCT_IMAGES_PATH
} from "../../constants/shopify.constant";
import BackgroundRectangleShape from "../../../design/components/design-editor/konva-editor/background-rectangle-shape";
import BackgroundProductImage from "../product-image/background-product-image";
import useImage from "use-image";
import {
    SHOPIFY_SHOP_LOGO_HORIZONTAL_100PX,
} from "../../constants/shopify-logo-image-horizontal.constant";
import {uploadSingleImageFile} from "../../../design/services/design-variant-file-data-service";
import {ArrowDownOnSquareIcon} from "@heroicons/react/24/solid";
import {getImageContainer} from "../../utils/product-image-util";

function downloadURI(uri, name) {
    let link = document.createElement('a');
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const DesignInstagramProductImage = ({
                                         settings,
                                         product,
                                         selectedImageTab,
                                         selectedProductImage,
                                         uploadAllImages,
                                         productImage,
                                         setProductImageDetail,
                                     }) => {
    const [initialStep, setInitialStep] = useState(true);
    const stageRef = React.useRef(null);
    const backgroundRef = React.useRef(null);
    const [stagePos, setStagePos] = useState(null);
    const [stageScale, setStageScale] = useState(1);
    const [stageSize, setStageSize] = useState(null);
    const [showStage, setShowStage] = useState(false);
    const [imageContainerClass, setImageContainerClass] = useState('');
    const [image] = useImage(SHOPIFY_SHOP_LOGO_HORIZONTAL_100PX, 'anonymous');
    const logoRef = React.useRef(null);
    // const [image] = useImage(SHOPIFY_SHOP_LOGO_HORIZONTAL_50PX, 'anonymous');
    // const [image] = useImage(SHOPIFY_SHOP_LOGO, 'anonymous');

    useEffect(() => {
        if (initialStep) {
            initStage();
        }
    }, [initialStep]);

    const initStage = () => {
        fitStageIntoParentContainer(INSTAGRAM_IMAGE_SIZE_1_TO_1);
        setShowStage(true);
        refreshStage();
    }

    useEffect(() => {
        if (selectedImageTab) {
            setShowStage(false);
            fitStageIntoParentContainer(getImageContainer(selectedImageTab.key));
            setShowStage(true);
            refreshStage();
        }
    }, [selectedImageTab]);

    useEffect(() => {
        if (selectedProductImage && selectedProductImage?.id === productImage?.id) {
            if (uploadAllImages) {
                uploadProductImage();
            } else {
                handleExport();
            }
        }
    }, [selectedProductImage]);

    const refreshStage = (triggerDownloadImage = false) => {
        setTimeout(() => {
            const stage = stageRef.current;
            stage.draw();
        }, 20);
    }

    const fitStageIntoParentContainer = (settings) => {
        const stage = stageRef.current;
        let container = document.querySelector('#stage-parent');
        // @ts-ignore
        let containerWidth = container?.offsetWidth - 2;
        let scale = containerWidth / settings?.width;

        setStageScale(scale);

        stage.width(settings?.width * scale);
        stage.height(settings?.height * scale);
        stage.scale({x: scale, y: scale});

        setStageSize({width: stage?.width(), height: stage?.height()});
    }

    const showHideLogo = (hideLogo) => {
        if (logoRef && logoRef.current) {
            // @ts-ignore
            logoRef.current.visible(!hideLogo);
        }
    }

    const handleExport = (hideLogo?) => {
        showHideLogo(hideLogo);

        const pixelRatio = 100 / (stageScale * 100);
        const uri = stageRef.current.toDataURL({
            pixelRatio: pixelRatio
        });

        showHideLogo(!hideLogo);

        downloadURI(uri, product?.handle + '-' + productImage.imageIndex + '.png');
    };

    const uploadProductImage = async () => {
        const pixelRatio = 100 / (stageScale * 100);
        const url = stageRef.current.toDataURL({
            pixelRatio: pixelRatio
        });

        const metaData = {
            contentType: "image/jpg",
            customMetadata: {
                productId: productImage.productId,
                imageId: productImage.id,
                imageIndex: productImage.imageIndex,
            }
        };

        await uploadSingleImageFile(productImage.imageFilePath, url, metaData);
    }

    return (
        <>

            <div className='ml-4'>
                <div className="mt-4 instagram-image-action-container bg-gray-300 border-t border-x border-gray-800">
                    <div className="flex justify-between items-center px-4 py-2">
                        <div className="font-bold">#{productImage.imageIndex}</div>

                        <div>
                            <button onClick={() => {
                                handleExport(true);
                            }}
                                    className="button-small-link py-2 px-3 mx-1 flex justify-center">
                                <div className="">
                                    <ArrowDownOnSquareIcon className="h-6 w-6"/>
                                </div>
                            </button>
                        </div>

                        {settings?.imagesUploaded &&
                            <div className="field-container">
                                <div className="justify-start flex">
                                    <input
                                        type="checkbox"
                                        className="h-6 w-6 mr-1"
                                        id={`${productImage?.id}-instagram`}
                                        name="instagram"
                                        value={productImage?.instagram}
                                        checked={productImage?.instagram}
                                        onChange={(event) => {
                                            setProductImageDetail(event, productImage);
                                        }}>
                                    </input>
                                    <div className=''>
                                        <label className='field-label self-center'
                                               htmlFor={`${productImage?.id}-instagram`}>Instagram</label>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                <div id="stage-parent"
                     className="">

                    <Stage width={stageSize?.width} height={stageSize?.height}
                           style={{'backgroundColor': '#FFFFFF'}}
                           className="flex justify-start border border-gray-800 shadow-lg"
                           draggable={false}
                           listening={false}
                           perfectDrawEnabled={false}
                           ref={stageRef}
                           scaleX={stageScale}
                           scaleY={stageScale}
                           x={stagePos?.x}
                           y={stagePos?.y}>

                        {showStage &&
                            <>

                                {selectedImageTab?.key !== 'original' && selectedImageTab?.key !== 'original-vertical' &&
                                    <Layer>
                                        <BackgroundRectangleShape
                                            backgroundRef={backgroundRef}
                                            background={settings?.background}
                                            stageWidth={settings?.width}
                                            stageHeight={settings?.height}/>
                                    </Layer>
                                }

                                <Layer>
                                    <BackgroundProductImage
                                        key={`product-image-${productImage.imageIndex}`}
                                        productImage={productImage}/>

                                    {selectedImageTab?.key !== 'original' && selectedImageTab?.key !== 'original-vertical' &&
                                        <Image
                                            ref={logoRef}
                                            name={'logo'}
                                            {...settings.logo}
                                            image={image}
                                            listening={false}/>
                                    }
                                </Layer>

                            </>
                        }

                    </Stage>
                </div>
            </div>

        </>
    )
}

export default DesignInstagramProductImage
